/**
 * Normalize free promotional line items (BXY / 100% off at price === 0) before
 * persist/sync. Discounted-but-paid promo lines (e.g. 20% off category) keep their
 * tax_items intact.
 *
 * Tax is deliberately NOT zeroed here: the order's tax_total/grand_total are
 * computed (via countSubtotal) before this normalization runs, using the item's
 * real pre-comp tax, and are never recalculated afterward. Zeroing an item's tax
 * here without adjusting the order aggregate desyncs order_ordertaxitem from the
 * order header (TaxesSummaryView vs SalesSummaryView), even though the customer
 * is still actually charged that tax as part of the order total.
 *
 * @param {Array<object>|null|undefined} items
 * @returns {Array<object>}
 */
export function normalizePromotionItemsForSync(items) {
  if (!Array.isArray(items)) return items;

  return items.map((item) => {
    if (!item || item.isPromotionItem !== true || Number(item.price) !== 0) {
      return item;
    }

    const normalized = { ...item };
    const basePrice =
      typeof normalized.default_price === "number"
        ? normalized.default_price
        : normalized.originalPrice || normalized.price || 0;
    normalized.price = basePrice;
    normalized.price_base = basePrice;
    normalized.price_before_tax = basePrice;
    normalized.subtotal = 0;
    normalized.grand_total = 0;
    return normalized;
  });
}

/**
 * @param {object} item order line
 * @param {number} perUnitDiscount promotion discount per unit
 * @param {number} perUnitWhole whole-order discount share per unit
 * @returns {{ promotion_applied: boolean, isPromotionItem: boolean }}
 */
export function promotionItemFlags(item, perUnitDiscount, perUnitWhole = 0) {
  const unitPrice = Number(item?.price ?? item?.price_base ?? 0);
  const hasPromoDiscount = perUnitDiscount > 0 || perUnitWhole > 0;
  return {
    promotion_applied: hasPromoDiscount,
    // Free promo lines only (matches calculateTaxes skip + sync normalize).
    isPromotionItem: unitPrice === 0 && hasPromoDiscount,
  };
}
